import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-10',
    header: 'flex flex-col gap-4',
    content: 'flex flex-col gap-6',
    title: 'heading-m text-secondary-hover',
    name: 'heading-2xl',
    info: 'flex items-center gap-6',
    count: 'heading-xs text-secondary-hover',
    addresses: 'flex flex-col gap-3',
    address:
      'hover:bg-blue-light hover:border-blue-light flex cursor-default gap-2 border border-[#BFD7F2] px-4 py-6 transition-colors duration-200',
    addressContent: 'flex flex-col gap-2',
    addressIcon: 'mt-0.5 size-6 min-w-6 text-[#BFD7F2]',
    addressName: 'heading-m-bold',
    addressLine: 'heading-s',
    addressPhone: 'heading-m-bold cursor-pointer text-black'
  }
});
